import clsx from 'clsx';
import Avatar from '@/components/Avatar';

export interface PrayerSidebarGroup {
  id: string;
  name: string;
  orgId: string;
  orgName: string;
  imageUrl?: string | null;
}

interface Props {
  group: PrayerSidebarGroup;
  unread: number;
  selected: boolean;
  onSelect: (group: PrayerSidebarGroup) => void;
}

/** Group row in the prayer sidebar tree (chat ConversationListItem pattern). */
export default function PrayerGroupListItem({ group, unread, selected, onSelect }: Props) {
  return (
    <button
      onClick={() => onSelect(group)}
      className={clsx(
        'flex w-full items-center gap-3 rounded-lg py-2 pl-6 pr-3 text-left transition',
        selected ? 'bg-flock-navy-100' : 'hover:bg-flock-navy-50'
      )}
    >
      <Avatar
        src={group.imageUrl}
        name={group.name}
        sizeClass="h-9 w-9"
        textClass="text-xs"
        bgClass="bg-flock-navy-500"
      />
      <span
        className={clsx(
          'min-w-0 flex-1 truncate text-sm',
          unread > 0 ? 'font-semibold text-flock-navy-900' : 'font-medium text-flock-navy-800'
        )}
      >
        {group.name}
      </span>
      {unread > 0 && (
        <span className="flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full bg-flock-navy-600 px-1.5 text-xs font-semibold text-white">
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </button>
  );
}
